import { useShoppingBasketInfoWithDefaultData } from '#src/clientState/providers';
import { PageErrorEnum } from '#src/components/PageError';
import { PageError } from '#src/components/public';
import React from 'react';

const isAnEmptyShoppingBasket = (bundles, products, loading) => {
  return (
    !loading &&
    products &&
    products?.length === 0 &&
    bundles &&
    bundles?.length === 0
  );
};

export const ShoppingBasketIsEmptyChecker = ({ children, empty }) => {
  const { bundles, products, loading } = useShoppingBasketInfoWithDefaultData();

  const isEmpty = isAnEmptyShoppingBasket(bundles, products, loading);

  if (isEmpty) {
    return empty;
  }
  return children;
};

export const EmptyManager = ({ children }) => {
  return (
    <ShoppingBasketIsEmptyChecker
      empty={
        <PageError pageErrorStatus={PageErrorEnum.SHOPPING_BASKET_EMPTY} />
      }
    >
      {children}
    </ShoppingBasketIsEmptyChecker>
  );
};
